import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './Home.css';

function Home() {
  const { user } = useAuth();
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const webSiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'GuyRules',
    description: "Etiquette, rules, and humor about guys—wife, tools, family, dating, sports, and life.",
    url: baseUrl + '/',
    potentialAction: {
      '@type': 'SearchAction',
      target: { '@type': 'EntryPoint', urlTemplate: baseUrl + '/search?q={search_term_string}' },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEO
        title="GuyRules – Etiquette, Rules & Humor for Guys"
        description="Etiquette, rules, and humor about guys—wife, tools, family, dating, sports, and life. Browse, vote, and submit Guy Rules."
        canonicalPath="/"
        jsonLd={webSiteJsonLd}
      />
      <Header />
      <div className="container">
        <div className="home-page">
          <h1 className="text-danger">Welcome to GuyRules</h1>
          
          <div className="welcome-content">
            <h2>What are GuyRules?</h2>
            <h3>
              GuyRules is a compilation of the rules that govern men's social behavior. GuyRules
              began as simply a sharing between guys during normal conversation. Eventually,
              we recognized that our ideas about guys' behavior weren't new; they just
              weren't chronicled. Using a pocket recorder, we began to compile humorous
              rules about men. We began the web site with 110 GuyRules of our own, written
              during various activities, including construction projects and sports
              events. Since then, guys from around the world have submitted their own
              rules to www.guyrules.com, and the popularity of the site has led us to
              write GuyRules the book for Andrews & McMeel. For the book,{' '}
              <a 
                href="http://www.amazon.com/exec/obidos/ASIN/0740700308/guyrules" 
                target="_blank" 
                rel="nofollow noreferrer"
              >
                Click Here
              </a>
            </h3>
          </div>
          
          <div className="home-actions">
            <Link to="/rules/latest" className="btn btn-primary">
              View Latest Rules
            </Link>
            <Link to="/rules/random" className="btn btn-secondary">
              Random Rule
            </Link>
            {user && (user.profile === 'admin' || user.profile === 'club') && (
              <Link to="/club-guydom" className="btn btn-primary">
                Club Guydom
              </Link>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Home;
